import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

export const readAllNews = createAsyncThunk('news/readAllNews', async (lang: string) => {
	return await NewsService.readAll(lang);
});
